import type { ImageCardProps } from '3-components/ImageCard/ImageCard';
import type { RealEstateMapItem } from '3-components/ListingMap/MapTypes';
import { type RealEstateListingQuery } from 'cms/cms';
import { resolveRealEstatePagesToImageCards } from './imageCardResolver';
import { resolveRealEstatePagesToMapItems, type RealEstatePageItems } from './mapItemResolver';


interface RealEstateListingData {
    total: number;
    cardItems: ImageCardProps[];
    mapItems: RealEstateMapItem[];
}

export const resolveRealEstateListing = (data: RealEstateListingQuery): RealEstateListingData | null => {
    const { items, total } = data.RealestatePage as NonNullable<RealEstateListingQuery['RealestatePage']>;

    return {
        total: Number(total),
        cardItems: resolveRealEstatePagesToImageCards(items as RealEstatePageItems),
        mapItems: resolveRealEstatePagesToMapItems(items as RealEstatePageItems),
    };
};
